<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Iniciar Sesión</h1>
                  <p class="text-muted">Iniciar sesión en su cuenta</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="Usuario"
                      autocomplete="username email"
                      v-model="email"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      class="form-control"
                      placeholder="Contraseña"
                      autocomplete="current-password"
                      v-model="password"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="5">
                      <b-button variant="success" class="px-4" @click="loginForm()">Ingresar</b-button>
                    </b-col>
                    <b-col cols="7" class="text-right">
                      <!-- <b-button variant="link" class="px-0">¿Olvido su contraseña?</b-button> -->
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-success py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Trebol Jurídico</h2>
                  <p>
                    Nuestro software está en versión Beta, esto quiere decir que
                    es posible que encuentre algunos errores durante la
                    presentación de su información en los siguientes días, en
                    caso de ser así, le agradecemos nos reporte dichos errores a
                    través del siguiente
                    <a
                      class="text-warning"
                      href="https://forms.gle/g4EBD7aEE6NouKAY9"
                      target="_blank"
                    >Formulario</a>
                  </p>

                  <!-- <img src="img/logo1.png" class="img-responsive" /> -->
                  <div class="profile-card-photo">
                    <img src="img/sin_gestion.png" alt width="100px" />
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      user: [],
    };
  },
  methods: {
    loginForm() {
      showLoader();

      localStorage.clear();

      let user = {
        email: this.email,
        password: this.password,
      };

      this.user = JSON.stringify(user);

      this.$http
        .post(`${this.$urlApi}auth/login`, this.user, {
          headers: { "Content-Type": "application/json" },
        })
        .then(function (response) {
          let token = response.body.token;
          let auth = response.body.auth;

          if (auth[0]["status"] !== "A") {
            hideLoader();
            this.$swal("Error", "El usuario se encuentra inactivo", "error");
            return;
          }

          localStorage.setItem("token", token);
          sessionStorage.setItem("token", token);

          let idRole = response.body.role_id;

          auth[0]["is_admin"] = response.body.is_admin;
          localStorage.setItem("auth", JSON.stringify(auth));
          localStorage.setItem("auth_is_admin", response.body.is_admin);
          localStorage.setItem("auth_image", response.body.image);
          localStorage.setItem("role_id", idRole);

          this.getOptionsRole(idRole, token);
          localStorage.setItem("readyMenu", "N"); // PARA CONTROLAR EL RELOAD DEL MENU

          hideLoader();
          this.$router.push("dashboard"); // redireccionar al home

          return false;
        })
        .catch((error) => {
          // debugger;
          console.log(error);
          hideLoader();
          if (error.body.action && error.body.action == "update") {
            this.$swal({
              title: "Advertencia",
              text: `${error.body.error}`,
              type: "warning",
              showCancelButton: true,
              confirmButtonText: "Actualizar",
              cancelButtonText: "Cerrar",
            }).then((result) => {
              if (result.value) {
                localStorage.setItem("user_id", error.body.id);
                this.$router.push("changepassword"); // redireccionar al cambio de contraseña
              }
            });
          } else this.$swal("Error", `${error.body.error}`, "error");
        });
    },
    getOptionsRole(idRole, token) {
      // BUSCAR LAS OPCIONES DEL SISTEMA A LAS CUALES TIENE PERMISO ESTE ROL
      this.$http
        .get(`${this.$urlApi}roleoptions/${idRole}?token=${token}`)
        .then(
          (responseAux) => {
            // CREAR LAS URL DEL ROL
            let lstData = responseAux.data.data;
            let items = [
              {
                title: false,
                name: "Dashboard",
                url: "/dashboard",
                icon: "icon-speedometer",
              },
            ];

            lstData.forEach(function (data, index) {
              let obj = {
                title: false,
                name: data.name,
                url: data.url,
                icon: "icon-user",
              };

              items.push(obj);
            });

            localStorage.setItem("options", JSON.stringify(items));

            console.log(items);
            //debugger
          },
          (error) => {
            console.log(error);
          }
        );
    },
  },
};
</script>
